import { render, staticRenderFns } from "./ActiveRooms.vue?vue&type=template&id=3256eaf6&scoped=true&"
import script from "./ActiveRooms.vue?vue&type=script&lang=js&"
export * from "./ActiveRooms.vue?vue&type=script&lang=js&"
import style0 from "./ActiveRooms.vue?vue&type=style&index=0&id=3256eaf6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3256eaf6",
  null
  
)

export default component.exports